import { toProjectBankInput } from './projectBankInput';

/**
 * `Project.bank` field saved by the block project-bank-self-employment. Must match
 * `ProjectBankSelfEmploymentInput` in the API schema.
 */
export const PROJECT_BANK_SELF_EMPLOYMENT_INPUT_FIELDS = ['selfEmploymentNetIncome'];

/** `ProjectBankSelfEmploymentInput` from the block object. */
export const toProjectBankSelfEmploymentInput = (project) =>
  toProjectBankInput(project, PROJECT_BANK_SELF_EMPLOYMENT_INPUT_FIELDS);
